import * as React from "react";
import type { SVGProps } from "react";
const SvgAddSquare04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M13 7.2a1 1 0 1 0-2 0h2m-2 9.6a1 1 0 1 0 2 0h-2m5.8-3.8a1 1 0 1 0 0-2v2m-9.6-2a1 1 0 1 0 0 2v-2m14.4 1h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm0 4.8h-1V12h2V7.2zm0 4.8h-1v4.8h2V12zm4.8 0v-1H12v2h4.8zM12 12v-1H7.2v2H12z"
    />
  </svg>
);
export default SvgAddSquare04;
